import '../scss/main-page-v3.scss';


import Swiper from 'swiper';
import {Autoplay, Navigation} from 'swiper/modules';

import menuModule from "./modules/menu.js";
import scrollUpModule from "./modules/scrollUpModule.js";
import footerModule from "./modules/footerModule.js";
// import sendPulseFormModule from "./modules/sendPulseFormModule.js";

(function ($) {

    $(document).ready(function () {

        window.$ = jQuery;

        menuModule.init();
        scrollUpModule.init();
        footerModule.init();
        // sendPulseFormModule.init();

        // Swiper-ы на главной странице
        new Swiper('.results-swiper', {
            slidesPerView: 3,
            spaceBetween: 20,
            breakpoints: {
                0: {
                    slidesPerView: 1.2,
                },
                576: {
                    slidesPerView: 2.2,
                },
                992: {
                    slidesPerView: 3,
                }
            }
        });

        new Swiper('.tpb-swiper', {
            modules: [Autoplay],
            autoplay: {
                delay: 3000,
                disableOnMouseEnter: true
            },
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 20,
            enabled: true,
            breakpoints: {
                769: {
                    enabled: false,
                }
            }
        });

        new Swiper('.self-swiper', {
            modules: [Autoplay],
            autoplay: {
                delay: 3000,
                disableOnMouseEnter: true
            },
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 20,
            enabled: true,
            breakpoints: {
                768: {
                    enabled: false,
                }
            }
        });

        new Swiper('.trew-swiper', {
            modules: [Navigation],
            navigation: {
                nextEl: '.button-next-self',
                prevEl: '.button-prev-self',
            },
            slidesPerView: 'auto',
            spaceBetween: 20,
        });

        // Вырубает стандартные сообщения валидации
        document.addEventListener('invalid', (function () {
            return function (e) {
                e.preventDefault();
                $(e.target).parent().addClass('has-error')
            };
        })(), true);

        $(document).on('submit', '[data-contact-form]', function (e) {
            e.preventDefault();

            const formData = $(this).serializeArray()
            let formDataConverted = {
                action: 'contact_mail'
            };

            formData.forEach(field => {
                formDataConverted[field.name] = field.value;
            });


            $.post(ajaxurl, formDataConverted, response => {
                const data = JSON.parse(response);
                alert(data.message);

                $(this).trigger('reset')
                $(this).find('.has-error').removeClass('has-error')
            });

            return false;
        });
    });

}(jQuery));



